<template>
	<div class="unknown-page-component">
		<h2>Neznámá komponenta stránky</h2>
		<p>V souboru <code>struts-config.xml</code> je tato stránka definovaná
			jako Vue komponenta. Název této komponenty
			nemá mapování na implementaci v souboru <code>PageResolver.ts</code>.</p>
		<p>Prověřte také, že ve <code>struts-config.xml</code> je správný atribut <code>component=&quot;...&quot;</code>.</p>
	</div>
</template>

<script setup lang="ts">
const props = defineProps({});
</script>

<style>
.unknown-page-component {
	background-color: #660000;
	color: #FFCCCC;
	padding: 32px;
	max-width: 400px;
	border: 1px solid #FF9999;
	border-radius: var(--panel-radius);
}
</style>